import getDisplayName from './get-display-name';

export default function createHocName(hocComponentName, WrappedComponent) {
  return `${hocComponentName}(${getDisplayName(WrappedComponent)})`;
}
